export const initialResetPasswordRequestForm: ResetPasswordRequestForm = {
  email: "",
};

export interface ResetPasswordRequestForm {
  email: string;
}
